module.exports = __webpack_public_path__ + "img/reset-step-four2.d24e70ed.png";